export const shareProfile = async (url) => {
  // 1. MOBILE SHARE SHEET
  if (navigator.share) {
    try {
      await navigator.share({
        title: "Check this profile",
        url,
      });
      return;
    } catch (err) {
      console.log("Share cancelled");
    }
  }

  // 2. DESKTOP FALLBACK → COPY LINK
  try {
    await navigator.clipboard.writeText(url);
    alert("Profile link copied to clipboard!");
  } catch (err) {
    console.log("Clipboard failed");
  }
};
